// 引入导出pdf的相关函数
import html2canvas from "html2canvas";
import JsPDF from "jspdf";

export function regTel(telPhone) {
  const reg = /^1(2|3|4|5|6|7|8|9)\d{9}$/;
  return reg.test(telPhone);
}

export function regIdcard(obj) {
  if (!obj) {
    return false;
  }
  let ereg;
  var idcard, Y, JYM;
  var S, M;
  var aCity = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "***",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 ",
    99: "信息保护 ",
  };
  idcard = obj = obj.replace(/(^\s*)|(\s*$)/g, "");
  if (!idcard) return true;
  if (aCity[parseInt(idcard.substr(0, 2))] == null) return 3;
  var idcard_array = new Array();
  idcard_array = idcard.split("");
  switch (idcard.length) {
    case 15:
      var Ai = idcard.slice(0, 6) + "19" + idcard.slice(6, 16);
      if (!/^\d+$/.test(Ai)) return 1;
      var yyyy = Ai.slice(6, 10),
        mm = Ai.slice(10, 12) - 1,
        dd = Ai.slice(12, 14);
      var d = new Date(yyyy, mm, dd),
        now = new Date();
      var year = d.getFullYear(),
        mon = d.getMonth(),
        day = d.getDate();
      if (year != yyyy || mon != mm || day != dd || d > now) return 1;
      return true;
    case 18:
      //18位身份号码检测
      //出生日期的合法性检查
      //闰年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))
      //平年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))
      if (
        parseInt(idcard.substr(6, 4)) % 4 == 0 ||
        (parseInt(idcard.substr(6, 4)) % 100 == 0 &&
          parseInt(idcard.substr(6, 4)) % 4 == 0)
      ) {
        ereg = /^[1-9][0-9]{5}[12]\d[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/; //闰年出生日期的合法性正则表达式
      } else {
        ereg = /^[1-9][0-9]{5}[12]\d[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/; //平年出生日期的合法性正则表达式
      }
      if (ereg.test(idcard)) {
        var tdddd = idcard.substring(6, 10);
        var cd = new Date().getFullYear();
        if (cd - tdddd < 0 || cd - tdddd > 120) {
          return 1;
        }
        //测试出生日期的合法性
        //计算校验位
        S =
          (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 +
          (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 +
          (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 +
          (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 +
          (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 +
          (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 +
          (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 +
          parseInt(idcard_array[7]) * 1 +
          parseInt(idcard_array[8]) * 6 +
          parseInt(idcard_array[9]) * 3;
        Y = S % 11;
        M = "F";
        JYM = "10X98765432";
        M = JYM.substr(Y, 1); //判断校验位
        if (idcard_array[17] == "x") idcard_array[17] = "X";
        if (M == idcard_array[17]) {
          return true; //检测ID的校验位
        } else {
          return 2;
        }
      } else {
        return 1;
      }
    default:
      return 0;
  }
}

/**
 * 邮箱
 * @param {*} s
 */
export function isEmail(s) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
    s
  );
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile(s) {
  return /^1[0-9]{10}$/.test(s);
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone(s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s);
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s);
}

/**
 * @description: 转义文本
 * @param {*}
 */
export function showcontent(str) {
  if (!str) {
    return;
  }
  let arrEntities = {
    lt: "<",
    gt: ">",
    nbsp: " ",
    amp: "&",
    hellip: "…",
    quot: '"',
    ldquo: "“",
    rdquo: "”",
    apos: "'",
    mdash:'—',
    middot:'·'
  };
  let newStr = str.replace(/&(lt|gt|nbsp|amp|quot|ldquo|rdquo|apos|mdash|middot|hellip);/gi, function(
    all,
    t
  ) {
    return arrEntities[t];
  });
  while(newStr.search(/&(lt|gt|nbsp|amp|quot|ldquo|rdquo|apos|mdash|middot|hellip);/gi)!==-1) {
    newStr = showcontent(newStr)
  }
  return newStr
}

export function getpdf() {
  let ele = document.getElementById("tableform");
  ele.style.background = "#ffffff";
  // 获得该容器的宽
  let eleW = ele.offsetWidth;
  // 获得该容器的高
  let eleH = ele.offsetHeight;
  // 获得该容器到文档顶部的距离
  let eleOffsetTop = ele.offsetTop;
  // 获得该容器到文档最左的距离
  let eleOffsetLeft = ele.offsetLeft;
  let canvas = document.createElement("canvas");
  let abs = 0;
  let win_in =
    document.documentElement.clientWidth || document.body.clientWidth;
  let win_out = window.innerWidth;
  if (win_out > win_in) {
    // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
    abs = (win_out - win_in) / 2; // 获得滚动条宽度的一半
  }
  canvas.width = eleW * 2; // 将画布宽&&高放大两倍
  canvas.height = eleH * 2;
  let context = canvas.getContext("2d");
  context.scale(2, 2);
  context.translate(-eleOffsetLeft - abs, -eleOffsetTop);
  // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
  // translate的时候，要把这个差值去掉
  // html2canvas(element).then( (canvas)=>{ //报错
  // html2canvas(element[0]).then( (canvas)=>{
  html2canvas(ele, {
    dpi: 900,
    // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
    useCORS: true, //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
  }).then((canvas) => {
    let contentWidth = canvas.width;
    let contentHeight = canvas.height;
    //一页pdf显示html页面生成的canvas高度;
    let pageHeight = (contentWidth / 592.28) * 841.89;
    //未生成pdf的html页面高度
    let leftHeight = contentHeight;
    //页面偏移
    let position = 0;
    //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
    let imgWidth = 595.28;
    let imgHeight = (595.28 / contentWidth) * contentHeight;
    let pageData = canvas.toDataURL("image/jpeg", 1.0);
    let pdf = new JsPDF("", "pt", "a4");
    //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
    //当内容未超过pdf一页显示的范围，无需分页
    if (leftHeight < pageHeight) {
      //在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
      pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
      // pdf.addImage(pageData, 'JPEG', 20, 40, imgWidth, imgHeight);
    } else {
      // 分页
      while (leftHeight > 0) {
        pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
        leftHeight -= pageHeight;
        position -= 841.89;
        //避免添加空白页
        if (leftHeight > 0) {
          pdf.addPage();
        }
      }
    }
    //可动态生成
    pdf.save("persons.pdf");
  });
}
